import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnnouncementsService, ContentLinkType } from '../../../../lib/announcements.service';
import { ModalService } from '../../../../lib/modal.service';
import { LogService } from '../../../../lib/log.service';
import { OrgTypeList, ContentLinkTypeList } from '../../../../lib/announcements.service';
@Component({
  selector: 'app-template-edit',
  templateUrl: './template-edit.component.html',
  styleUrls: ['./template-edit.component.scss']
})
export class TemplateEditComponent implements OnInit {
  templateForm: FormGroup;
  config: any;
  isEditing = false;
  isNew = false;
  submitButtonPressed = false;
  organizationTypes = OrgTypeList;
  linkOptions = ContentLinkTypeList;
  selectedOrgType = OrgTypeList[0].id;
  selectedLink = ContentLinkType.NONE;

  constructor(
    private formBuilder: FormBuilder,
    private announcementsService: AnnouncementsService,
    private modalService: ModalService,
    private logService: LogService,
    public dialogRef: MatDialogRef<TemplateEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.config = {
        toolbar: [
            { name: 'formatting', items: ['PasteFromWord'] },
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-'] },
            { name: 'links', items: ['Link', 'Unlink'] },
            { name: 'paragraph', items: ['NumberedList', 'BulletedList'] }
        ]
    };
    this.templateForm = this.formBuilder.group({
      Title: ['', Validators.required],
      Content: ['', Validators.required],
      OrgType: ['', Validators.required],
      Link: ['']
    });
    this.data = data.data;
    
  }

  ngOnInit(): void {
    if (this.data?.templateId) {
      if (this.data.isEditing) {   
        this.isEditing = true;
      } else {
        this.isEditing = false;
      }
      this.loadTemplate(this.data.templateId);
    }
    else {
      this.isNew = true;
    }
  }

  isViewMode(): boolean {
    return !this.isEditing && !this.isNew;
  }

  loadTemplate(id: number): void {
    this.announcementsService.getTemplate(id).subscribe(
      (template) => {
        this.templateForm.patchValue({
          Title: template.Title,
          Content: template.Content,
          OrgType: template.OrgType,
          Link: template.Link
        });
      },
      (error) => {
        this.logService.error(`Error loading template: ${error}`);
        this.modalService.showAlert('Error', 'Failed to load template');
        this.dialogRef.close();
      }
    );
  }

  onLinkSelect(link: string): void {
    const content = this.templateForm.get('Content')?.value;
    if (link === ContentLinkType.NONE) {
        if (content.includes('Click <a href="">here</a> to get begin!')) {
            this.templateForm.patchValue({
                Content: content.replace('Click <a href="">here</a> to get begin!', '')
            });
        }
    } else {
        if (!content.includes('Click <a href="">here</a> to get begin!')) {
            this.templateForm.patchValue({
                Content: content + 'Click <a href="">here</a> to get begin!'
            });
        }
    }
  }

  onSubmit(): void {
    if (this.isViewMode()) {
      this.dialogRef.close();
      return;
    }
    this.submitButtonPressed = true;
    
    if (this.templateForm.valid) {
      const templateData = this.templateForm.value;
      
      if (this.isEditing && this.data?.templateId) {
        this.announcementsService.updateTemplate(this.data.templateId, templateData).subscribe(
          () => {
            this.dialogRef.close(true);
            this.modalService.showAlert('Success', 'Template updated successfully');
          },
          (error) => {
            this.logService.error(`Error updating template: ${error}`);
            this.modalService.showAlert('Error', 'Failed to update template');
          }
        );
      } else {
        this.announcementsService.createTemplate(templateData).subscribe(
          () => {
            this.dialogRef.close(true);
            this.modalService.showAlert('Success', 'Template created successfully');
          },
          (error) => {
            this.logService.error(`Error creating template: ${error}`);
            this.modalService.showAlert('Error', 'Failed to Create New Template');
          }
        );
      }
    }
  }
} 